var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.48051 1C5.40877 1 5.34508 1.04591 5.32239 1.11396L5.02705 2H8.97295L8.67761 1.11396C8.65492 1.04591 8.59123 1 8.51949 1H5.48051ZM10.027 2L9.62629 0.797734C9.46749 0.321335 9.02166 0 8.51949 0H5.48051C4.97834 0 4.53251 0.321335 4.37371 0.797734L3.97295 2H2.33333H1C0.723858 2 0.5 2.22386 0.5 2.5C0.5 2.77614 0.723858 3 1 3H1.86556L2.37664 10.6663C2.46419 11.9795 3.55495 13 4.87111 13H9.12889C10.4451 13 11.5358 11.9795 11.6234 10.6663L12.1344 3H13C13.2761 3 13.5 2.77614 13.5 2.5C13.5 2.22386 13.2761 2 13 2H11.6667H10.027ZM11.1322 3H9.66667H4.33333H2.86778L3.37443 10.5998C3.42696 11.3877 4.08141 12 4.87111 12H9.12889C9.91859 12 10.573 11.3877 10.6256 10.5998L11.1322 3ZM5.66667 4.66667C5.94281 4.66667 6.16667 4.89052 6.16667 5.16667V9.83333C6.16667 10.1095 5.94281 10.3333 5.66667 10.3333C5.39052 10.3333 5.16667 10.1095 5.16667 9.83333V5.16667C5.16667 4.89052 5.39052 4.66667 5.66667 4.66667ZM8.83333 5.16667C8.83333 4.89052 8.60948 4.66667 8.33333 4.66667C8.05719 4.66667 7.83333 4.89052 7.83333 5.16667V7.83333C7.83333 8.10948 8.05719 8.33333 8.33333 8.33333C8.60948 8.33333 8.83333 8.10948 8.83333 7.83333V5.16667Z",
    fill: "#CE371C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedTrash);
export default __webpack_public_path__ + "static/media/red-trash.b3fb315a75d0935f5bd8683df2b5125b.svg";
export { ForwardRef as ReactComponent };